import { FC, useEffect } from "react";
import Slider, { Settings } from "react-slick";
import { TestimonialsProps } from "../../testimonials.types";
import styles from "./testimonials-2.module.css";
import { UiButton } from "@ui-monorepo/index";
import TestimonialsCard from "../../components/testimonials-card/testimonials-card";
import useTestimonials from "../../testimonials.hook";
import WidgetContainer from "../../../widget-container";

type SliderArrowProps = {className?: string;onClick?: () => void;};

const Testimonials2: FC<TestimonialsProps> = (props) => {
  const {
    t,
    sliderRef,
    testimonials,
    highLight,
    testimonialType,
    sliderLoad,
    setSliderLoad,
    handleChange
  } = useTestimonials(props);

  const SliderArrow = ({ className, onClick }: SliderArrowProps) => {
    return (
      <UiButton
        isBlack
        appearance='icon'
        className={className || ""}
        leftIcon={<span className='icon-arrow-right' />}
        onClick={onClick}
        theme={props.theme} />);


  };

  const settings = (): Settings => {
    return {
      className: `${styles.testimmonial2Slider} ${
      testimonials?.length === 1 ? "slider-simple-center" : ""
      } ${sliderLoad ? styles.sliderLoaded : ""}`,
      dots: false,
      arrows: true,
      infinite: testimonials?.length > 2,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      focusOnSelect: false,
      prevArrow: <SliderArrow />,
      nextArrow: <SliderArrow />,
      beforeChange: () => {
        if (sliderRef.current?.innerSlider?.list) {
          const sliderHeight = sliderRef.current.innerSlider.list.offsetHeight;
          sliderRef.current.innerSlider.list.style.height = `${sliderHeight}px`;
        }
      },
      afterChange: (current: number) => {
        handleChange(current);
        if (sliderRef.current?.innerSlider?.list) {
          resizeSliderByActive(sliderRef.current.innerSlider.list);
        }
      },
      onReInit: () => {
        if (!sliderLoad) {
          setTimeout(() => {
            if (sliderRef.current?.innerSlider?.list) {
              resizeSliderByActive(sliderRef.current?.innerSlider?.list);
            }
          }, 400);
          setSliderLoad(true);
        }
      },
      responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: false,
          arrows: true,
          infinite: true,
          centerMode: false,
          variableWidth: false
        }
      }]

    };
  };

  const resizeSliderByActive = (list: HTMLDivElement) => {
    const sliderTrack = list.querySelector(".slick-track");
    const slideActive = list.querySelector(".slick-active");
    if (sliderTrack && slideActive) {
      list.style.height = `${
      parseInt(
        window.getComputedStyle(sliderTrack).getPropertyValue("padding-top")
      ) +
      parseInt(
        window.
        getComputedStyle(sliderTrack).
        getPropertyValue("padding-bottom")
      ) +
      slideActive.clientHeight
      }px`;
    }
  };

  return (
    <WidgetContainer highlight={highLight}>
      <div className={styles.testimonial2} aria-label='testimonial2Container'>
        <h2 className={styles.testimonial2Title}>
          {t(
            `testimonials.title.${
            testimonialType === "CUSTOMER" ? "clients" : "allies"
            }`
          )}
        </h2>
        <Slider ref={sliderRef} {...settings()}>
          {testimonials?.map((testimonial, index) =>
          <TestimonialsCard
            type='circle'
            testimonial={testimonial}
            key={`testimonials-circle-${index}`}
            className={`testimonialItem testimonialItem${index}`} />

          )}
        </Slider>
      </div>
    </WidgetContainer>);

};

export default Testimonials2;